module.exports = __webpack_public_path__ + "static/media/house.e2083134.svg";